import { isCompanyUser } from "@/utils/roleStorage";

export const TaleText = ({
  role,
  children,
  className,
  applyEffect = true,
  style = {},
  ...props
}) => {
  const resolvedRole = role ?? (isCompanyUser() ? "business" : "normal");

  const businessStyle = {
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
  };
  const normalStyle = {
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
  };
  return (
    <span
      className={`${
        !applyEffect
          ? ""
          : resolvedRole === "business"
          ? "bg-tale-business"
          : "bg-tale-normal"
      }  ${className ?? ""}`}
      style={{
        ...style,
        ...(!applyEffect
          ? {}
          : resolvedRole === "business"
          ? businessStyle
          : normalStyle),
      }}
      {...props}
    >
      {children}
    </span>
  );
};
